/**
 * @description 获取环境变量值
 * @returns env 环境变量，值在test, pre, prod之间
 */
import { getEnvironmentByURL } from "mpfe-utils"

const getEnvironment = function(){
    var env = 'prod'
    try{
        const EnvFromJava = window.deployEnv
        var clientEnv = window && window.MptcfeUtils && getEnvironmentByURL()
        var buildEnv = RUNNINGENV || NODE_ENV
        var initialEnv = EnvFromJava || buildEnv || clientEnv
        var lowerCase = initialEnv.toLowerCase()
        if(lowerCase.includes('test') || lowerCase.includes('dev')){
            env = 'test'
        }
        lowerCase.includes('pre') && (env = 'pre')
        lowerCase.includes('prod') && (env = 'prod')
    }catch(error){
        console.log('环境判断遇到异常',error)
        env = 'prod'
    }
    console.log('环境判断结果',env)
    return env
}

var env = getEnvironment()

export {
    getEnvironment,
    env,
}

